import { useEffect } from 'react';
import { useLocation } from 'wouter';

/**
 * Hook to restore scroll position to top when location changes
 */
export function useScrollRestoration() {
  const [location] = useLocation();

  useEffect(() => {
    // Scroll to top when location changes
    window.scrollTo(0, 0);
  }, [location]);
}